import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
export function StyleGuidePage() {
  const [copiedText, setCopiedText] = useState('');
  const copyToClipboard = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    setCopiedText(label);
    setTimeout(() => setCopiedText(''), 2000);
  };
  return <div className="w-full min-h-screen bg-white pt-24 pb-20" data-id="element-1609">
      <div className="container mx-auto px-6" data-id="element-1610">
        <div className="max-w-6xl mx-auto" data-id="element-1611">
          {/* Header */}
          <div className="mb-20" data-id="element-1612">
            <Link to="/" className="text-black hover:text-gray-700 transition-colors inline-flex items-center mb-8" data-id="element-1613">
              ← Volver al inicio
            </Link>
            <h1 className="text-5xl md:text-6xl font-normal text-black mb-6" data-id="element-1614">
              Guía de Estilos
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl" data-id="element-1615">
              Sistema de diseño completo para explorandoconfran. Esta guía
              documenta todos los elementos visuales, patrones de diseño y
              principios que definen nuestra identidad de marca.
            </p>
          </div>

          {/* Design Principles */}
          <section className="mb-24" data-id="element-1616">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1617">
              Principios de Diseño
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1618">
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1619">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1620">
                  Autenticidad
                </h3>
                <p className="text-base text-gray-700 leading-relaxed" data-id="element-1621">
                  Cada elemento visual refleja experiencias reales. Sin filtros
                  excesivos, sin artificios. El diseño es honesto y directo.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1622">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1623">
                  Claridad
                </h3>
                <p className="text-base text-gray-700 leading-relaxed" data-id="element-1624">
                  La información se presenta de manera clara y accesible.
                  Jerarquía visual limpia, espaciado generoso, tipografía
                  legible.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1625">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1626">
                  Minimalismo
                </h3>
                <p className="text-base text-gray-700 leading-relaxed" data-id="element-1627">
                  Menos es más. Cada elemento tiene un propósito. El espacio en
                  blanco es tan importante como el contenido.
                </p>
              </div>
            </div>
          </section>

          {/* Color Palette */}
          <section className="mb-24" data-id="element-1628">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1629">
              Paleta de Colores
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1630">
              <div data-id="element-1631">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1632">
                  Colores Primarios
                </h3>
                <div className="space-y-4" data-id="element-1633">
                  <div className="group cursor-pointer" onClick={() => copyToClipboard('#000000', 'Negro')} data-id="element-1634">
                    <div className="h-24 bg-black rounded-lg mb-3 relative overflow-hidden" data-id="element-1635">
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/20" data-id="element-1636">
                        <span className="text-white text-sm" data-id="element-1637">
                          {copiedText === 'Negro' ? '✓ Copiado' : 'Click para copiar'}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center" data-id="element-1638">
                      <span className="text-base font-medium text-black" data-id="element-1639">
                        Negro
                      </span>
                      <span className="text-sm text-gray-600" data-id="element-1640">#000000</span>
                    </div>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-1641">
                      Texto principal, botones primarios, elementos de énfasis
                    </p>
                  </div>
                  <div className="group cursor-pointer" onClick={() => copyToClipboard('#FFFFFF', 'Blanco')} data-id="element-1642">
                    <div className="h-24 bg-white rounded-lg border border-gray-200 mb-3 relative overflow-hidden" data-id="element-1643">
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-gray-100/50" data-id="element-1644">
                        <span className="text-black text-sm" data-id="element-1645">
                          {copiedText === 'Blanco' ? '✓ Copiado' : 'Click para copiar'}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center" data-id="element-1646">
                      <span className="text-base font-medium text-black" data-id="element-1647">
                        Blanco
                      </span>
                      <span className="text-sm text-gray-600" data-id="element-1648">#FFFFFF</span>
                    </div>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-1649">
                      Fondo principal, tarjetas, áreas de contenido
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-1650">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1651">
                  Escala de Grises
                </h3>
                <div className="space-y-4" data-id="element-1652">
                  {[{
                  name: 'Gray 50',
                  hex: '#F9FAFB',
                  use: 'Fondos sutiles, secciones alternas'
                }, {
                  name: 'Gray 100',
                  hex: '#F3F4F6',
                  use: 'Fondos de tarjetas, áreas deshabilitadas'
                }, {
                  name: 'Gray 200',
                  hex: '#E5E7EB',
                  use: 'Bordes, divisores'
                }, {
                  name: 'Gray 600',
                  hex: '#4B5563',
                  use: 'Texto secundario, etiquetas'
                }, {
                  name: 'Gray 700',
                  hex: '#374151',
                  use: 'Texto de apoyo, subtítulos'
                }].map(color => <div key={color.name} className="group cursor-pointer" onClick={() => copyToClipboard(color.hex, color.name)} data-id="element-1653">
                      <div className="flex items-center gap-4" data-id="element-1654">
                        <div className="h-16 w-16 rounded-lg relative overflow-hidden flex-shrink-0" style={{
                      backgroundColor: color.hex
                    }} data-id="element-1655">
                          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/10" data-id="element-1656">
                            <span className="text-xs text-black" data-id="element-1657">
                              {copiedText === color.name ? '✓' : ''}
                            </span>
                          </div>
                        </div>
                        <div className="flex-1" data-id="element-1658">
                          <div className="flex justify-between items-center mb-1" data-id="element-1659">
                            <span className="text-sm font-medium text-black" data-id="element-1660">
                              {color.name}
                            </span>
                            <span className="text-xs text-gray-600" data-id="element-1661">
                              {color.hex}
                            </span>
                          </div>
                          <p className="text-xs text-gray-600" data-id="element-1662">{color.use}</p>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </section>

          {/* Typography */}
          <section className="mb-24" data-id="element-1663">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1664">Tipografía</h2>
            <div className="bg-gray-50 p-8 rounded-lg mb-8" data-id="element-1665">
              <h3 className="text-xl font-normal text-black mb-6" data-id="element-1666">
                Familia Tipográfica
              </h3>
              <div className="space-y-6" data-id="element-1667">
                <div data-id="element-1668">
                  <p className="text-base text-gray-700 mb-2" data-id="element-1669">
                    <span className="font-medium" data-id="element-1670">Sistema:</span> -apple-system,
                    BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
                    Arial, sans-serif
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-1671">
                    Utilizamos la fuente del sistema para garantizar la máxima
                    legibilidad y rendimiento en todas las plataformas.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-12" data-id="element-1672">
              <div data-id="element-1673">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1674">
                  Escala Tipográfica
                </h3>
                <div className="space-y-8 bg-gray-50 p-8 rounded-lg" data-id="element-1675">
                  {[{
                  size: 'text-5xl',
                  weight: 'font-normal',
                  label: 'H1 - Hero',
                  example: 'explorandoconfran'
                }, {
                  size: 'text-4xl',
                  weight: 'font-normal',
                  label: 'H2 - Sección',
                  example: 'Audiencia y Alcance'
                }, {
                  size: 'text-3xl',
                  weight: 'font-normal',
                  label: 'H3 - Subsección',
                  example: 'Lo que más significa'
                }, {
                  size: 'text-2xl',
                  weight: 'font-normal',
                  label: 'H4 - Título',
                  example: 'Media Kit'
                }, {
                  size: 'text-xl',
                  weight: 'font-normal',
                  label: 'H5 - Subtítulo',
                  example: 'Contenido Auténtico'
                }, {
                  size: 'text-lg',
                  weight: 'font-normal',
                  label: 'Párrafo Grande',
                  example: 'Más de 17 mil almas curiosas me acompañan en cada camino.'
                }, {
                  size: 'text-base',
                  weight: 'font-normal',
                  label: 'Párrafo Normal',
                  example: 'Juntos recorremos montañas, ríos y senderos que cuentan historias.'
                }, {
                  size: 'text-sm',
                  weight: 'font-normal',
                  label: 'Texto Pequeño',
                  example: 'Visualizaciones (últimos 60 días)'
                }].map(type => <div key={type.label} className="border-b border-gray-200 pb-6 last:border-0" data-id="element-1676">
                      <p className={`${type.size} ${type.weight} text-black mb-2`} data-id="element-1677">
                        {type.example}
                      </p>
                      <div className="flex items-center gap-4 text-sm text-gray-600" data-id="element-1678">
                        <span className="font-medium" data-id="element-1679">{type.label}</span>
                        <span data-id="element-1680">•</span>
                        <code className="bg-white px-2 py-1 rounded text-xs" data-id="element-1681">
                          {type.size} {type.weight}
                        </code>
                      </div>
                    </div>)}
                </div>
              </div>

              <div data-id="element-1682">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1683">
                  Pesos de Fuente
                </h3>
                <div className="bg-gray-50 p-8 rounded-lg space-y-6" data-id="element-1684">
                  <div data-id="element-1685">
                    <p className="text-2xl font-normal text-black mb-2" data-id="element-1686">
                      Normal (400)
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1687">
                      Uso principal para títulos y encabezados. Crea jerarquía
                      sin peso excesivo.
                    </p>
                  </div>
                  <div data-id="element-1688">
                    <p className="text-2xl font-medium text-black mb-2" data-id="element-1689">
                      Medium (500)
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1690">
                      Para énfasis dentro del texto, etiquetas importantes y
                      CTAs secundarios.
                    </p>
                  </div>
                </div>
              </div>

              <div data-id="element-1691">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1692">
                  Interlineado y Espaciado
                </h3>
                <div className="bg-gray-50 p-8 rounded-lg space-y-6" data-id="element-1693">
                  <div data-id="element-1694">
                    <p className="text-base font-medium text-black mb-2" data-id="element-1695">
                      leading-relaxed (1.625)
                    </p>
                    <p className="text-base text-gray-700 leading-relaxed" data-id="element-1696">
                      Utilizado en párrafos largos para mejorar la legibilidad.
                      Este es un ejemplo de texto con interlineado relajado que
                      facilita la lectura de contenido extenso y permite que el
                      texto respire.
                    </p>
                  </div>
                  <div data-id="element-1697">
                    <p className="text-base font-medium text-black mb-2" data-id="element-1698">
                      leading-normal (1.5)
                    </p>
                    <p className="text-base text-gray-700 leading-normal" data-id="element-1699">
                      Interlineado estándar para texto general y descripciones
                      cortas. Proporciona un equilibrio entre densidad y
                      legibilidad.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Spacing System */}
          <section className="mb-24" data-id="element-1700">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1701">
              Sistema de Espaciado
            </h2>
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1702">
              <div className="space-y-8" data-id="element-1703">
                <div data-id="element-1704">
                  <h3 className="text-xl font-normal text-black mb-6" data-id="element-1705">
                    Escala de Espaciado
                  </h3>
                  <div className="space-y-6" data-id="element-1706">
                    {[{
                    name: 'py-20 (5rem / 80px)',
                    use: 'Márgenes verticales de sección',
                    visual: 'h-20'
                  }, {
                    name: 'py-12 (3rem / 48px)',
                    use: 'Espaciado entre subsecciones',
                    visual: 'h-12'
                  }, {
                    name: 'py-8 (2rem / 32px)',
                    use: 'Padding de tarjetas y contenedores',
                    visual: 'h-8'
                  }, {
                    name: 'py-6 (1.5rem / 24px)',
                    use: 'Espaciado entre elementos relacionados',
                    visual: 'h-6'
                  }, {
                    name: 'py-4 (1rem / 16px)',
                    use: 'Espaciado interno de componentes',
                    visual: 'h-4'
                  }].map(space => <div key={space.name} className="flex items-center gap-6" data-id="element-1707">
                        <div className={`${space.visual} w-4 bg-black rounded flex-shrink-0`} data-id="element-1708"></div>
                        <div className="flex-1" data-id="element-1709">
                          <p className="text-base font-medium text-black mb-1" data-id="element-1710">
                            {space.name}
                          </p>
                          <p className="text-sm text-gray-600" data-id="element-1711">{space.use}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                <div data-id="element-1712">
                  <h3 className="text-xl font-normal text-black mb-6" data-id="element-1713">
                    Contenedor Principal
                  </h3>
                  <div className="bg-white p-6 rounded-lg border-2 border-dashed border-gray-300" data-id="element-1714">
                    <code className="text-sm text-gray-700" data-id="element-1715">
                      container mx-auto px-6
                    </code>
                    <p className="text-sm text-gray-600 mt-2" data-id="element-1716">
                      Ancho máximo con márgenes automáticos y padding horizontal
                      de 1.5rem (24px)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Components */}
          <section className="mb-24" data-id="element-1717">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1718">
              Componentes
            </h2>

            {/* Buttons */}
            <div className="mb-16" data-id="element-1719">
              <h3 className="text-xl font-normal text-black mb-6" data-id="element-1720">Botones</h3>
              <div className="space-y-8" data-id="element-1721">
                <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1722">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-1723">
                    Botón Primario
                  </h4>
                  <div className="flex flex-wrap gap-4 mb-6" data-id="element-1724">
                    <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors" data-id="element-1725">
                      Colaboremos
                    </button>
                    <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors rounded-full" data-id="element-1726">
                      Hablemos
                    </button>
                  </div>
                  <div className="bg-white p-4 rounded border border-gray-200" data-id="element-1727">
                    <code className="text-xs text-gray-700 block mb-2" data-id="element-1728">
                      bg-black text-white px-8 py-3 text-sm uppercase
                      hover:bg-gray-800 transition-colors
                    </code>
                    <p className="text-sm text-gray-600" data-id="element-1729">
                      Uso: Acciones principales, CTAs importantes. El texto
                      siempre en mayúsculas para mayor impacto.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1730">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-1731">
                    Botón Secundario
                  </h4>
                  <div className="flex flex-wrap gap-4 mb-6" data-id="element-1732">
                    <button className="border border-black px-8 py-3 text-sm uppercase hover:bg-gray-100 transition-colors" data-id="element-1733">
                      Ver Más
                    </button>
                    <button className="border border-black px-8 py-3 text-sm uppercase hover:bg-gray-100 transition-colors rounded" data-id="element-1734">
                      Solicitar
                    </button>
                  </div>
                  <div className="bg-white p-4 rounded border border-gray-200" data-id="element-1735">
                    <code className="text-xs text-gray-700 block mb-2" data-id="element-1736">
                      border border-black px-8 py-3 text-sm uppercase
                      hover:bg-gray-100 transition-colors
                    </code>
                    <p className="text-sm text-gray-600" data-id="element-1737">
                      Uso: Acciones secundarias, navegación alternativa.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1738">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-1739">
                    Enlace de Texto
                  </h4>
                  <div className="flex flex-wrap gap-6 mb-6" data-id="element-1740">
                    <a href="#" className="text-black hover:text-gray-700 transition-colors" data-id="element-1741">
                      ← Volver
                    </a>
                    <a href="#" className="text-black hover:text-gray-700 transition-colors inline-flex items-center" data-id="element-1742">
                      Ver más en Instagram
                      <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-1743">
                        <path d="M5 12h14M12 5l7 7-7 7" data-id="element-1744" />
                      </svg>
                    </a>
                  </div>
                  <div className="bg-white p-4 rounded border border-gray-200" data-id="element-1745">
                    <code className="text-xs text-gray-700 block mb-2" data-id="element-1746">
                      text-black hover:text-gray-700 transition-colors
                    </code>
                    <p className="text-sm text-gray-600" data-id="element-1747">
                      Uso: Navegación, enlaces contextuales, acciones
                      terciarias.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Cards */}
            <div className="mb-16" data-id="element-1748">
              <h3 className="text-xl font-normal text-black mb-6" data-id="element-1749">Tarjetas</h3>
              <div className="space-y-8" data-id="element-1750">
                <div data-id="element-1751">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-1752">
                    Tarjeta Básica
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6" data-id="element-1753">
                    <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-1754">
                      <h3 className="text-xl font-normal text-black mb-4" data-id="element-1755">
                        Contenido Auténtico
                      </h3>
                      <p className="text-base text-gray-600 leading-relaxed" data-id="element-1756">
                        Historias contadas con honestidad y cuidado.
                        Experiencias reales que hacen que la gente no solo mire,
                        sino que quiera ser parte de ellas.
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded" data-id="element-1757">
                    <code className="text-xs text-gray-700 block mb-2" data-id="element-1758">
                      bg-white p-8 rounded-lg shadow-sm
                    </code>
                    <p className="text-sm text-gray-600" data-id="element-1759">
                      Uso: Características, testimonios, contenido informativo.
                    </p>
                  </div>
                </div>

                <div data-id="element-1760">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-1761">
                    Tarjeta con Borde Superior
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6" data-id="element-1762">
                    <div className="border-t-2 border-black pt-8 bg-white p-8 rounded-lg shadow-sm" data-id="element-1763">
                      <h3 className="text-xl font-medium text-black mb-3" data-id="element-1764">
                        Cobertura de Eventos
                      </h3>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1765">
                        Desde 12,000 MXN
                      </p>
                      <p className="text-base text-gray-600 leading-relaxed" data-id="element-1766">
                        Documentamos tu evento como si fuera una expedición:
                        desde la energía inicial hasta el último momento de
                        celebración.
                      </p>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded" data-id="element-1767">
                    <code className="text-xs text-gray-700 block mb-2" data-id="element-1768">
                      border-t-2 border-black pt-8 bg-white p-8 rounded-lg
                      shadow-sm
                    </code>
                    <p className="text-sm text-gray-600" data-id="element-1769">
                      Uso: Planes de precios, servicios destacados, ofertas
                      especiales.
                    </p>
                  </div>
                </div>

                <div data-id="element-1770">
                  <h4 className="text-lg font-medium text-black mb-4" data-id="element-1771">
                    Tarjeta de Fondo Gris
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6" data-id="element-1772">
                    <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1773">
                      <h3 className="text-xl font-normal text-black mb-4" data-id="element-1774">
                        TikTok
                      </h3>
                      <div className="grid grid-cols-2 gap-6" data-id="element-1775">
                        <div data-id="element-1776">
                          <p className="text-4xl font-normal text-black mb-2" data-id="element-1777">
                            10K
                          </p>
                          <p className="text-sm text-gray-600" data-id="element-1778">Seguidores</p>
                        </div>
                        <div data-id="element-1779">
                          <p className="text-4xl font-normal text-black mb-2" data-id="element-1780">
                            299K
                          </p>
                          <p className="text-sm text-gray-600" data-id="element-1781">
                            Visualizaciones
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded" data-id="element-1782">
                    <code className="text-xs text-gray-700 block mb-2" data-id="element-1783">
                      bg-gray-50 p-8 rounded-lg
                    </code>
                    <p className="text-sm text-gray-600" data-id="element-1784">
                      Uso: Estadísticas, datos destacados, secciones
                      informativas.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Forms */}
            <div data-id="element-1785">
              <h3 className="text-xl font-normal text-black mb-6" data-id="element-1786">
                Formularios
              </h3>
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1787">
                <div className="max-w-md" data-id="element-1788">
                  <div className="mb-6" data-id="element-1789">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1790">
                      Nombre
                    </label>
                    <input type="text" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black transition-all" placeholder="Tu nombre" data-id="element-1791" />
                  </div>
                  <div className="mb-6" data-id="element-1792">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1793">
                      Email
                    </label>
                    <input type="email" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black transition-all" placeholder="tu@email.com" data-id="element-1794" />
                  </div>
                  <div className="mb-6" data-id="element-1795">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1796">
                      Mensaje
                    </label>
                    <textarea rows={4} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black transition-all resize-none" placeholder="Escribe tu mensaje aquí" data-id="element-1797"></textarea>
                  </div>
                </div>
                <div className="bg-white p-4 rounded border border-gray-200 mt-6" data-id="element-1798">
                  <code className="text-xs text-gray-700 block mb-2" data-id="element-1799">
                    w-full px-4 py-3 border border-gray-300 rounded-md
                    focus:ring-2 focus:ring-black focus:border-black
                  </code>
                  <p className="text-sm text-gray-600" data-id="element-1800">
                    Inputs con estados de focus claros y transiciones suaves.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Layout Patterns */}
          <section className="mb-24" data-id="element-1801">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1802">
              Patrones de Layout
            </h2>
            <div className="space-y-12" data-id="element-1803">
              <div data-id="element-1804">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1805">
                  Grid de 2 Columnas
                </h3>
                <div className="bg-gray-50 p-8 rounded-lg mb-4" data-id="element-1806">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1807">
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1808">
                      <span className="text-sm text-gray-600" data-id="element-1809">Columna 1</span>
                    </div>
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1810">
                      <span className="text-sm text-gray-600" data-id="element-1811">Columna 2</span>
                    </div>
                  </div>
                </div>
                <code className="text-sm text-gray-700 bg-white px-4 py-2 rounded border border-gray-200 inline-block" data-id="element-1812">
                  grid grid-cols-1 md:grid-cols-2 gap-8
                </code>
              </div>

              <div data-id="element-1813">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1814">
                  Grid de 3 Columnas
                </h3>
                <div className="bg-gray-50 p-8 rounded-lg mb-4" data-id="element-1815">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1816">
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1817">
                      <span className="text-sm text-gray-600" data-id="element-1818">Columna 1</span>
                    </div>
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1819">
                      <span className="text-sm text-gray-600" data-id="element-1820">Columna 2</span>
                    </div>
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1821">
                      <span className="text-sm text-gray-600" data-id="element-1822">Columna 3</span>
                    </div>
                  </div>
                </div>
                <code className="text-sm text-gray-700 bg-white px-4 py-2 rounded border border-gray-200 inline-block" data-id="element-1823">
                  grid grid-cols-1 md:grid-cols-3 gap-8
                </code>
              </div>

              <div data-id="element-1824">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1825">
                  Grid de 4 Columnas
                </h3>
                <div className="bg-gray-50 p-8 rounded-lg mb-4" data-id="element-1826">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1827">
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1828">
                      <span className="text-sm text-gray-600" data-id="element-1829">Col 1</span>
                    </div>
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1830">
                      <span className="text-sm text-gray-600" data-id="element-1831">Col 2</span>
                    </div>
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1832">
                      <span className="text-sm text-gray-600" data-id="element-1833">Col 3</span>
                    </div>
                    <div className="h-32 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1834">
                      <span className="text-sm text-gray-600" data-id="element-1835">Col 4</span>
                    </div>
                  </div>
                </div>
                <code className="text-sm text-gray-700 bg-white px-4 py-2 rounded border border-gray-200 inline-block" data-id="element-1836">
                  grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8
                </code>
              </div>
            </div>
          </section>

          {/* Icons & Images */}
          <section className="mb-24" data-id="element-1837">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1838">
              Iconografía e Imágenes
            </h2>
            <div className="space-y-8" data-id="element-1839">
              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1840">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1841">
                  Librería de Iconos
                </h3>
                <p className="text-base text-gray-700 mb-6 leading-relaxed" data-id="element-1842">
                  Utilizamos <span className="font-medium" data-id="element-1843">Lucide React</span>{' '}
                  para todos los iconos. Estilo minimalista con trazo de 1.5px.
                </p>
                <div className="flex flex-wrap gap-8 items-center" data-id="element-1844">
                  <div className="flex flex-col items-center" data-id="element-1845">
                    <div className="w-12 h-12 flex items-center justify-center mb-2" data-id="element-1846">
                      <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1847">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-1848"></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-1849"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-1850"></line>
                      </svg>
                    </div>
                    <span className="text-xs text-gray-600" data-id="element-1851">Instagram</span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-1852">
                    <div className="w-12 h-12 flex items-center justify-center mb-2" data-id="element-1853">
                      <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1854">
                        <line x1="3" y1="12" x2="21" y2="12" data-id="element-1855"></line>
                        <line x1="3" y1="6" x2="21" y2="6" data-id="element-1856"></line>
                        <line x1="3" y1="18" x2="21" y2="18" data-id="element-1857"></line>
                      </svg>
                    </div>
                    <span className="text-xs text-gray-600" data-id="element-1858">Menu</span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-1859">
                    <div className="w-12 h-12 flex items-center justify-center mb-2" data-id="element-1860">
                      <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1861">
                        <path d="M18 6L6 18M6 6l12 12" data-id="element-1862" />
                      </svg>
                    </div>
                    <span className="text-xs text-gray-600" data-id="element-1863">Close</span>
                  </div>
                </div>
                <div className="mt-6 bg-white p-4 rounded border border-gray-200" data-id="element-1864">
                  <code className="text-xs text-gray-700" data-id="element-1865">
                    strokeWidth="1.5" strokeLinecap="round"
                    strokeLinejoin="round"
                  </code>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1866">
                <h3 className="text-xl font-normal text-black mb-6" data-id="element-1867">
                  Tratamiento de Imágenes
                </h3>
                <div className="space-y-4" data-id="element-1868">
                  <div data-id="element-1869">
                    <p className="text-base font-medium text-black mb-2" data-id="element-1870">
                      Esquinas Redondeadas
                    </p>
                    <p className="text-sm text-gray-600 mb-4" data-id="element-1871">
                      Todas las imágenes usan{' '}
                      <code className="bg-white px-2 py-1 rounded text-xs" data-id="element-1872">
                        rounded-lg
                      </code>{' '}
                      para mantener consistencia visual.
                    </p>
                    <div className="w-48 h-32 bg-gray-300 rounded-lg" data-id="element-1873"></div>
                  </div>
                  <div data-id="element-1874">
                    <p className="text-base font-medium text-black mb-2" data-id="element-1875">
                      Object Cover
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1876">
                      <code className="bg-white px-2 py-1 rounded text-xs" data-id="element-1877">
                        object-cover
                      </code>{' '}
                      para mantener proporciones sin distorsión.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Animations & Transitions */}
          <section className="mb-24" data-id="element-1878">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1879">
              Animaciones y Transiciones
            </h2>
            <div className="bg-gray-50 p-8 rounded-lg space-y-8" data-id="element-1880">
              <div data-id="element-1881">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1882">
                  Principios de Movimiento
                </h3>
                <p className="text-base text-gray-700 mb-6 leading-relaxed" data-id="element-1883">
                  Las transiciones son sutiles y funcionales. Usamos{' '}
                  <code className="bg-white px-2 py-1 rounded text-xs" data-id="element-1884">
                    transition-colors
                  </code>{' '}
                  para cambios de estado suaves sin distraer del contenido.
                </p>
              </div>

              <div data-id="element-1885">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1886">
                  Ejemplos de Transiciones
                </h3>
                <div className="space-y-6" data-id="element-1887">
                  <div data-id="element-1888">
                    <p className="text-sm font-medium text-black mb-3" data-id="element-1889">
                      Hover en Botones
                    </p>
                    <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors" data-id="element-1890">
                      Hover Me
                    </button>
                    <code className="block mt-2 text-xs text-gray-700 bg-white px-4 py-2 rounded" data-id="element-1891">
                      hover:bg-gray-800 transition-colors
                    </code>
                  </div>

                  <div data-id="element-1892">
                    <p className="text-sm font-medium text-black mb-3" data-id="element-1893">
                      Hover en Enlaces
                    </p>
                    <a href="#" className="text-black hover:text-gray-700 transition-colors inline-block" data-id="element-1894">
                      Hover sobre este enlace
                    </a>
                    <code className="block mt-2 text-xs text-gray-700 bg-white px-4 py-2 rounded" data-id="element-1895">
                      hover:text-gray-700 transition-colors
                    </code>
                  </div>

                  <div data-id="element-1896">
                    <p className="text-sm font-medium text-black mb-3" data-id="element-1897">
                      Focus en Inputs
                    </p>
                    <input type="text" className="w-full max-w-md px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black transition-all" placeholder="Click para ver el efecto de focus" data-id="element-1898" />
                    <code className="block mt-2 text-xs text-gray-700 bg-white px-4 py-2 rounded" data-id="element-1899">
                      focus:ring-2 focus:ring-black focus:border-black
                      transition-all
                    </code>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Best Practices */}
          <section className="mb-24" data-id="element-1900">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1901">
              Mejores Prácticas
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1902">
              <div className="bg-green-50 border-l-4 border-green-600 p-6 rounded-lg" data-id="element-1903">
                <h3 className="text-lg font-medium text-black mb-4 flex items-center" data-id="element-1904">
                  <span className="text-green-600 mr-2" data-id="element-1905">✓</span>
                  Hacer
                </h3>
                <ul className="space-y-3 text-sm text-gray-700" data-id="element-1906">
                  <li data-id="element-1907">• Usar espaciado consistente (sistema de 4px)</li>
                  <li data-id="element-1908">• Mantener jerarquía visual clara</li>
                  <li data-id="element-1909">• Usar font-normal para títulos</li>
                  <li data-id="element-1910">• Aplicar leading-relaxed en párrafos largos</li>
                  <li data-id="element-1911">• Usar transiciones sutiles en interacciones</li>
                  <li data-id="element-1912">• Mantener contraste adecuado (WCAG AA)</li>
                  <li data-id="element-1913">• Usar rounded-lg para imágenes y tarjetas</li>
                </ul>
              </div>

              <div className="bg-red-50 border-l-4 border-red-600 p-6 rounded-lg" data-id="element-1914">
                <h3 className="text-lg font-medium text-black mb-4 flex items-center" data-id="element-1915">
                  <span className="text-red-600 mr-2" data-id="element-1916">✗</span>
                  Evitar
                </h3>
                <ul className="space-y-3 text-sm text-gray-700" data-id="element-1917">
                  <li data-id="element-1918">• Usar múltiples pesos de fuente</li>
                  <li data-id="element-1919">• Agregar sombras excesivas</li>
                  <li data-id="element-1920">• Usar colores fuera de la paleta</li>
                  <li data-id="element-1921">• Crear layouts complejos innecesarios</li>
                  <li data-id="element-1922">• Animaciones llamativas o distractoras</li>
                  <li data-id="element-1923">• Texto con bajo contraste</li>
                  <li data-id="element-1924">• Mezclar estilos de botones</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Accessibility */}
          <section className="mb-24" data-id="element-1925">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1926">
              Accesibilidad
            </h2>
            <div className="bg-gray-50 p-8 rounded-lg space-y-6" data-id="element-1927">
              <div data-id="element-1928">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1929">
                  Contraste de Color
                </h3>
                <p className="text-base text-gray-700 mb-4 leading-relaxed" data-id="element-1930">
                  Todos los textos cumplen con WCAG 2.1 nivel AA:
                </p>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-1931">
                  <li data-id="element-1932">• Negro sobre blanco: 21:1 (AAA)</li>
                  <li data-id="element-1933">• Gray-700 sobre blanco: 10.7:1 (AAA)</li>
                  <li data-id="element-1934">• Gray-600 sobre blanco: 7.2:1 (AA)</li>
                </ul>
              </div>

              <div data-id="element-1935">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1936">
                  Navegación por Teclado
                </h3>
                <p className="text-base text-gray-700 leading-relaxed" data-id="element-1937">
                  Todos los elementos interactivos son accesibles por teclado
                  con estados de focus visibles usando{' '}
                  <code className="bg-white px-2 py-1 rounded text-xs" data-id="element-1938">
                    focus:ring-2 focus:ring-black
                  </code>
                </p>
              </div>

              <div data-id="element-1939">
                <h3 className="text-xl font-normal text-black mb-4" data-id="element-1940">
                  Texto Alternativo
                </h3>
                <p className="text-base text-gray-700 leading-relaxed" data-id="element-1941">
                  Todas las imágenes incluyen atributos alt descriptivos. Los
                  iconos decorativos usan aria-hidden="true".
                </p>
              </div>
            </div>
          </section>

          {/* Download Section */}
          <section className="bg-black text-white p-12 rounded-lg text-center" data-id="element-1942">
            <h2 className="text-3xl font-normal mb-4" data-id="element-1943">
              ¿Listo para usar esta guía?
            </h2>
            <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-1944">
              Esta guía de estilos está diseñada para mantener consistencia
              visual en todos los puntos de contacto de explorandoconfran.
            </p>
            <Link to="/" className="bg-white text-black px-8 py-3 text-sm uppercase hover:bg-gray-100 transition-colors inline-block rounded" data-id="element-1945">
              Volver al Inicio
            </Link>
          </section>
        </div>
      </div>
    </div>;
}